import LanguageTemplate from '@components/templates/settings/ui/language';

export default function LanguagesPage() {
  return <LanguageTemplate />;
}
